//
//
//
//
//
//
//

export default {
  props: {
    value: {
      type: Boolean,
      required: false,
    },
    nativeValue: {
      type: Boolean,
      default: true,
    },
    isHighlighted: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      validationValue: this.value,
    }
  },
  watch: {
    validationValue(newValue) {
      this.$emit('input', newValue)
    },
    value(newValue) {
      this.validationValue = newValue
    },
  },
}
